import { takeLatest, put, all, call } from "redux-saga/effects";

import FunderActionTypes from "./funder.types";
import {
  funderDetailsAdd,
  funderDetailsUpdate,
  funderListGet,
  funderDetailsFetch,
  funderDetailsDelete,
  fetchListFunder,
} from "./funder.service";

import {
  addFunderDetailsSuccess,
  addFunderDetailsFailure,
  addFunderDetailsResponseChanged,
  updateFunderDetailsSuccess,
  updateFunderDetailsFailure,
  updateFunderDetailsResponseChanged,
  getFunderListSuccess,
  getFunderListFailure,
  getFunderListResponseChanged,
  fetchFunderDetailsSuccess,
  fetchFunderDetailsFailure,
  fetchFunderDetailsResponseChanged,
  deleteFunderDetailsSuccess,
  deleteFunderDetailsFailure,
  deleteFunderDetailsResponseChanged,
  funderListFetchFailure,
  funderListFetchSuccess,
  funderListFetchResponseChanged,
} from "./funder.action";
import { encryptData } from "../../_common/enode-decode";

/** *********************  START GET FUNDER LIST  ******************** */
export function* funderDetailsListGet({ payload }: any) {
  const { CompanyID, searchValueSet, limit, InstanceName } = payload;
  try {
    const key = "GetAllFunderPaginationKey";
    const jsonData = {
      CompanyID: CompanyID,
      InputSearch: searchValueSet,
      Limit: limit,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(funderListGet, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(getFunderListFailure(responseData.data));
    } else {
      yield put(getFunderListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(getFunderListFailure(error));
  }
}

export function* resetGetFunderListResponse() {
  yield put(getFunderListResponseChanged());
}

export function* onGetFunderListDetails() {
  yield takeLatest(
    FunderActionTypes.GET_FUNDER_LIST_START,
    funderDetailsListGet,
  );
}

export function* onGetFunderListResponseReset() {
  yield takeLatest(
    FunderActionTypes.GET_FUNDER_LIST_RESPONSE_RESET,
    resetGetFunderListResponse,
  );
}
/** *********************  END GET FUNDER LIST ******************** */

/** *********************  START ADD FUNDER DETAILS  ******************** */
export function* createFunder({ payload }: any) {
  const { FunderName, CompanyID, UserName, UserID, InstanceName } = payload;
  try {
    const key = "CreateFunderKey";
    const jsonData = {
      FunderName: FunderName,
      CompanyID: CompanyID,
      UserName: UserName,
      CreatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(funderDetailsAdd, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(addFunderDetailsFailure(responseData.data));
    } else {
      yield put(addFunderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(addFunderDetailsFailure(error));
  }
}

export function* resetAddFunderResponse() {
  yield put(addFunderDetailsResponseChanged());
}

export function* onCreateFunderDetails() {
  yield takeLatest(FunderActionTypes.ADD_FUNDER_DETAILS_START, createFunder);
}

export function* onCreateFunderResponseReset() {
  yield takeLatest(
    FunderActionTypes.ADD_FUNDER_DETAILS_RESPONSE_RESET,
    resetAddFunderResponse,
  );
}
/** *********************  END ADD FUNDER DETAILS ******************** */

/** *********************  START UPDATE FUNDER DETAILS  ******************** */
export function* funderUpdate({ payload }: any) {
  const {
    FunderID,
    FunderName,
    oldFunderName,
    CompanyID,
    UserName,
    UserID,
    InstanceName,
  } = payload;
  try {
    const key = "UpdateFunderKey";
    const jsonData = {
      FunderID: FunderID,
      FunderName: FunderName,
      OldFunderName: oldFunderName,
      CompanyID: CompanyID,
      UserName: UserName,
      UpdatedBy: UserID,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(funderDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateFunderDetailsFailure(responseData.data));
    } else {
      yield put(updateFunderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateFunderDetailsFailure(error));
  }
}

export function* resetUpdateFunderDetailsResponse() {
  yield put(updateFunderDetailsResponseChanged());
}

export function* onUpdateFunderDetails() {
  yield takeLatest(FunderActionTypes.UPDATE_FUNDER_DETAILS_START, funderUpdate);
}

export function* onUpdateFunderResponseReset() {
  yield takeLatest(
    FunderActionTypes.UPDATE_FUNDER_DETAILS_RESPONSE_RESET,
    resetUpdateFunderDetailsResponse,
  );
}
/** *********************  END UPDATE FUNDER DETAILS ******************** */

/** *********************  START DELETE FUNDER DETAILS  ******************** */
export function* funderDelete({ payload }: any) {
  const { CompanyID, FunderID, FunderName, UserID, UserName, InstanceName } =
    payload;
  try {
    const key = "DeleteFunderKey";
    const jsonData = {
      CompanyID: CompanyID,
      FunderID: FunderID,
      FunderName: FunderName,
      DeletedBy: UserID,
      UserName: UserName,
      InstanceName: InstanceName,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(funderDetailsDelete, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(deleteFunderDetailsFailure(responseData.data));
    } else {
      yield put(deleteFunderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(deleteFunderDetailsFailure(error));
  }
}

export function* resetDeleteFunderDetailsResponse() {
  yield put(deleteFunderDetailsResponseChanged());
}

export function* onDeleteFunderDetail() {
  yield takeLatest(FunderActionTypes.DELETE_FUNDER_DETAILS_START, funderDelete);
}

export function* onDeleteFunderResponseReset() {
  yield takeLatest(
    FunderActionTypes.DELETE_FUNDER_DETAILS_RESPONSE_RESET,
    resetDeleteFunderDetailsResponse,
  );
}
/** *********************  END DELETE FUNDER DETAILS ******************** */

/** *********************  START FETCH FUNDER DETAILS  ******************** */
export function* fetchFunderData({ payload }: any) {
  const { CompanyID, FunderID, InstanceName } = payload;
  try {
    const key = "FetchFunderKey";
    const jsonData = {
      CompanyID: CompanyID,
      FunderID: FunderID,
      InstanceName: InstanceName,
    };

    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(funderDetailsFetch, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(fetchFunderDetailsFailure(responseData.data));
    } else {
      yield put(fetchFunderDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchFunderDetailsFailure(error));
  }
}

export function* resetFetchFunderDetailsResponse() {
  yield put(fetchFunderDetailsResponseChanged());
}

export function* onFetchFunderDetails() {
  yield takeLatest(
    FunderActionTypes.FETCH_FUNDER_DETAILS_START,
    fetchFunderData,
  );
}

export function* onFetchFunderResponseReset() {
  yield takeLatest(
    FunderActionTypes.FETCH_FUNDER_DETAILS_RESPONSE_RESET,
    resetFetchFunderDetailsResponse,
  );
}
/** *********************  END FETCH FUNDER DETAILS ******************** */

/** *********************** START FUNDER FETCH LIST ************************ */
export function* funderListFetch({ payload }: any) {
  const key: any = "AllFunderMasterKey";
  const { CompanyID, InstanceName } = payload;
  try {
    const jsonData: any = {
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchListFunder, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(funderListFetchFailure(responseData.data));
    } else {
      yield put(funderListFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(funderListFetchFailure(error));
  }
}

export function* funderFetchResponseReset() {
  yield put(funderListFetchResponseChanged());
}

export function* onFetchListFunders() {
  yield takeLatest(FunderActionTypes.FUNDER_LIST_FETCH_START, funderListFetch);
}

export function* onFunderListFetchResponseReset() {
  yield takeLatest(
    FunderActionTypes.FUNDER_LIST_RESPONSE_RESET_START,
    funderFetchResponseReset,
  );
}
/** *********************** END FUNDER FETCH LIST ************************ */

export function* funderMasterSaga() {
  yield all([
    call(onCreateFunderDetails),
    call(onCreateFunderResponseReset),
    call(onUpdateFunderDetails),
    call(onUpdateFunderResponseReset),
    call(onGetFunderListDetails),
    call(onGetFunderListResponseReset),
    call(onFetchFunderDetails),
    call(onFetchFunderResponseReset),
    call(onDeleteFunderDetail),
    call(onDeleteFunderResponseReset),
    call(onFetchListFunders),
    call(onFunderListFetchResponseReset),
  ]);
}
